module.exports = __webpack_public_path__ + "4fe5acddf03b3877649362c68ed65554.pdf";